import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  // The gated docs portal is a full-screen app shell with its own chrome.
  if (pathname.startsWith("/docs")) {
    return <>{children}</>;
  }
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <a href="#main-content" className="ek-skip-link" data-testid="skip-to-content">
        Skip to content
      </a>
      <Header />
      <main id="main-content" className="flex-1 pt-[132px]" data-testid="main-content" tabIndex={-1}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
